export default "__VITE_ASSET__CuSMgcYJ__"